import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProperty } from '../context/PropertyContext';
import { Building, Home, Star, Zap } from 'lucide-react';

const CategorySection: React.FC = () => {
  const navigate = useNavigate();
  const { setSearchFilters } = useProperty();

  const categories = [
    {
      id: 'residential',
      name: 'Residencial',
      description: 'Casas, apartamentos e imóveis para morar',
      icon: Home,
      color: 'bg-blue-500',
      hoverColor: 'hover:bg-blue-600'
    },
    {
      id: 'commercial',
      name: 'Comercial',
      description: 'Salas, lojas e imóveis para negócios',
      icon: Building,
      color: 'bg-green-500',
      hoverColor: 'hover:bg-green-600'
    },
    {
      id: 'standard',
      name: 'Padrão',
      description: 'Anúncios padrão com boa visibilidade',
      icon: Star,
      color: 'bg-gray-500',
      hoverColor: 'hover:bg-gray-600'
    },
    {
      id: 'destaque',
      name: 'Destaque',
      description: 'Anúncios em destaque com visibilidade especial',
      icon: Zap,
      color: 'bg-orange-500',
      hoverColor: 'hover:bg-orange-600'
    }
  ];

  const handleCategoryClick = (category: string) => {
    setSearchFilters({
      location: '',
      priceMin: 0,
      priceMax: 10000000,
      bedrooms: 0,
      suites: 0,
      parkingSpaces: 0,
      transactionType: category === 'residential' || category === 'commercial' ? '' : '',
      type: '',
      category: ''
    });
    navigate('/busca');
  };

  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Encontre por Categoria
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Explore nossa seleção de imóveis organizados por categoria para encontrar 
            exatamente o que você procura.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category) => {
            const Icon = category.icon;
            return (
              <button
                key={category.id}
                onClick={() => handleCategoryClick(category.name)}
                className={`${category.color} ${category.hoverColor} text-white p-6 rounded-xl transition-all duration-300 hover:shadow-lg hover:transform hover:scale-105`}
              >
                <div className="flex flex-col items-center text-center">
                  <div className="bg-white bg-opacity-20 p-3 rounded-full mb-4">
                    <Icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{category.name}</h3>
                  <p className="text-sm opacity-90">{category.description}</p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;